import {NgModule} from '@angular/core';
import {L10nModule} from '../translate';
import {LanguageSelectorComponent} from './language-selector.component';

@NgModule({
    imports: [
        L10nModule
    ],
    declarations: [
        LanguageSelectorComponent
    ],
    exports: [
        LanguageSelectorComponent
    ]
})
export class LanguageSelectorModule {}
